module.exports = __webpack_public_path__ + "static/lunchtype22-light-webfont-67e18551f00d5053e466a0af56e7fc6c.woff";